import { render, staticRenderFns } from "./gzlc.vue?vue&type=template&id=79eca2e0&scoped=true&"
import script from "./gzlc.vue?vue&type=script&lang=js&"
export * from "./gzlc.vue?vue&type=script&lang=js&"
import style0 from "./gzlc.vue?vue&type=style&index=0&id=79eca2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eca2e0",
  null
  
)

export default component.exports